<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="group.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Роли</label>
            <crm-standard-multi-select
              [descriptorApiUrl]="roleDropdownDescriptorUrl"
              [(selectedValues)]="group.roles"
              appendTo="body"></crm-standard-multi-select>
            <small
              *ngIf="errors?.roles"
              class="p-error">
              {{ errors.roles | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Компании</label>
            <crm-company-multi-select
              [(selectedCompanies)]="group.companies"
              [styleClass]="errors?.companies ? 'ng-invalid ng-dirty' : ''"
              [class]="errors?.companies ? 'ng-invalid ng-dirty' : ''"
              [isFloatLabel]="false"
              appendTo="body">
            </crm-company-multi-select>

            <small
              *ngIf="errors?.companies"
              class="p-error">
              {{ errors.companies | join }}
            </small>
          </div>
        </div>
      </p-card>
    </div>
  </div>

  <div
    *ngIf="(form$ | async)?.canWrite"
    class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success"
        (onClick)="saveGroup()"></crm-button>
      <crm-button
        *ngIf="(form$ | async)?.isShowDelete"
        label="Удалить"
        styleClass="p-button-danger p-button-text"
        (onClick)="deleteGroup()"></crm-button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
